import parseSRT from 'parse-srt';
import stripTags from './strip-tags-service';
import SubtitleService from './subtitle-service';
import TimeFormatService from './time-format-service';
import _ from 'lodash';

const SRTService = {
	parse: (data) => {
		// check for malformed times
		const lines = data.split('\n');
		lines.forEach((line) => {
			if(line.includes(' --> ')) {
				const range = line.split(' --> ');
				if(!TimeFormatService.isValidTime(range[0]) || !TimeFormatService.isValidTime(range[1])) {
					throw new Error('Malformed SRT file');
				}
			}
		});

		return parseSRT(data)
			.map(({ start, end, text }) => ({
				startTime: SubtitleService.offsetToTimecode(start),
				stopTime: SubtitleService.offsetToTimecode(end),
				text: text.replace(/<br \/>/, '\n')
			}));
	},

	export: (lines) => {
		let result = '';
		let i = 1;

		lines.forEach((line) => {
			if(line.text === undefined) {
				return;
			}

			line.text = line.text.replace(/&nbsp;/g, ' ');

			// A contenteditable line break only wraps the line AFTER the break in
			// a <div> - the first line is left bare (e.g. "line1<div>line2</div>").
			// Treating only the closing tag as a separator fuses that first pair
			// of lines together, so the opening tag has to introduce the break
			// instead; the closing tag is just discarded.
			let text = _.unescape(
				line.text
					.replace(/<br\s*\/?>/gi, '\n')
					.replace(/<div\b[^>]*>/gi, '\n')
					.replace(/<\/div>/gi, '')
					.replace(/\r\n/g, '\n')
					.replace(/\r/g, '\n')
			);

			// Remove any tags that may have made it into the translation (div tags seem to be the main problem).
			// <b> <i> <u> are the only two supported tags currently
			text = stripTags(text, '<b><i><u>').replace(/^\n+|\n+$/g, '');

			result += (i++) + '\n';
			result += TimeFormatService.startTime(line) + ' --> ' + TimeFormatService.stopTime(line) + '\n';
			result += text + '\n\n';
		});
		return result;
	}
};

export default SRTService;
